import React from "react";
import { CheckCircle2, Wallet } from "lucide-react";

/* Winning-ticket payout line: wins land in the wallet instantly — never shows "pending / verifying". */
export function HoldTracker({ bet, ta }) {
  if (bet.status !== "won") return null;
  const credited = !!bet.win_credited;
  return (
    <div className={`mt-2 rounded-lg px-2.5 py-2 text-[11px] ${credited ? "bg-emerald-50" : "bg-blue-50"}`} data-testid={`hold-tracker-${bet.id}`} data-state={credited ? "credited" : "processing"}>
      <div className="flex items-center gap-1.5 text-emerald-700 font-bold">
        <CheckCircle2 className="w-3.5 h-3.5" />{ta ? "வென்றது" : "Won"}
        <span className="flex-1 h-px bg-emerald-300" />
        <Wallet className={`w-3.5 h-3.5 ${credited ? "" : "animate-pulse text-blue-700"}`} />{ta ? "Wallet-ல் சேர்ந்தது" : "In your wallet"}
      </div>
      <div className="mt-1 text-slate-600">
        {credited ? (ta ? "✅ வெற்றித் தொகை wallet-ல் சேர்ந்தது — Withdraw-ல் எடுக்கலாம்." : "✅ Winnings are in your wallet — withdraw any time.")
          : (ta ? "⏳ Wallet-ல் சேர்கிறது — சில நொடிகளில்." : "⏳ Landing in your wallet — a few seconds.")}
      </div>
    </div>
  );
}
